import Footer from "../components/Footer";
import logo from "../images/casa_di_pietra_logo.webp";
import "../styles/privacy-policy.css";

export default function PrivacyPolicy() {
    return (
        <>
            <div className="col-12 col-lg-8 m-auto py-4">
                <section className="d-flex flex-column justify-content-between align-items-center flex-wrap pb-4">
                    <div className="mx-auto d-flex align-items-center flex-column">
                        <img src={logo} alt="logo" className="col-3" />
                        <div className="d-flex justify-content-center border-bottom border-1 font-regular spaced text-center border-green">
                            <span className="pb-2 fs-small">
                                <a
                                    href="../#history"
                                    className="text-decoration-none text-inherit mx-1"
                                >
                                    HISTÓRIA
                                </a>{" "}
                                |{" "}
                                <a
                                    href="../#experiences"
                                    className="text-decoration-none text-inherit mx-1"
                                >
                                    EXPERIÊNCIAS
                                </a>{" "}
                                |{" "}
                                <a
                                    href="../#suites"
                                    className="text-decoration-none text-inherit mx-1"
                                >
                                    SUÍTES
                                </a>{" "}
                                |{" "}
                                <a
                                    href="../#social"
                                    className="text-decoration-none text-inherit mx-1"
                                >
                                    CONTATOS
                                </a>
                            </span>
                        </div>
                    </div>
                </section>

                <section className="py-4 my-4">
                    <div style={{ width: "fit-content" }} className="ms-2 ms-lg-0">
                        <span className="m-0 fs-4 font-regular ps-1">política de</span>
                        <h1
                            className="mb-4 redwood-hollow fs-big-title pt-1"
                            style={{ opacity: "0.4", lineHeight: "0.7" }}
                        >
                            PRIVACIDADE
                        </h1>
                    </div>

                    <article className="privacy-policy-copy col-10 col-lg-9 mx-auto">
                        <p>
                            Esta Política de Privacidade explica como a Casa Di Pietra - Villa
                            Toscana coleta, usa, compartilha, armazena e gerencia dados pessoais
                            quando você interage com nosso chatbot no WhatsApp.
                        </p>

                        <p className="privacy-policy-meta">Data de vigência: 24 de março de 2026</p>

                        <p>
                            A Casa di Pietra - Villa Toscana ("Casa di Pietra", "nós", "nosso" ou
                            "nossa") disponibiliza um chatbot via WhatsApp para atendimento inicial
                            de pessoas interessadas em conhecer nosso espaço para eventos e
                            solicitar informações como materiais comerciais, janelas de
                            disponibilidade e propostas.
                        </p>

                        <h2>1. Escopo</h2>
                        <p>
                            Esta Política de Privacidade se aplica aos dados pessoais tratados por
                            meio do nosso chatbot no WhatsApp e dos sistemas de backend
                            relacionados, utilizados para:
                        </p>
                        <ul>
                            <li>
                                receber mensagens enviadas via WhatsApp por clientes em potencial;
                            </li>
                            <li>compreender o contexto da conversa;</li>
                            <li>responder perguntas sobre o espaço;</li>
                            <li>enviar mensagens de acompanhamento e documentos de proposta; e</li>
                            <li>
                                encaminhar a conversa para um representante humano quando o
                                atendimento automatizado não for suficiente.
                            </li>
                        </ul>

                        <h2>2. Informações que Coletamos</h2>
                        <p>
                            Quando você entra em contato conosco pelo WhatsApp, podemos coletar e
                            tratar as seguintes categorias de informações:
                        </p>
                        <ul>
                            <li>
                                identificadores do WhatsApp e dados de contato, como seu número de
                                telefone no WhatsApp e os identificadores associados às suas
                                mensagens;
                            </li>
                            <li>
                                informações de perfil disponibilizadas pelo WhatsApp, como seu nome
                                de exibição;
                            </li>
                            <li>
                                conteúdo das mensagens, incluindo o texto que você nos envia e
                                qualquer contexto indicando que sua mensagem é uma resposta a uma
                                mensagem anterior do bot;
                            </li>
                            <li>
                                detalhes da conversa que podem ser inferidos a partir das suas
                                mensagens para fins de atendimento, como ano do evento, estimativa
                                de convidados e preferência por datas durante a semana ou aos finais
                                de semana;
                            </li>
                            <li>
                                dados operacionais e técnicos, como metadados do payload do webhook,
                                dados de resposta de API, logs de erro, registros de data e hora e
                                identificadores de entrega de mensagens;
                            </li>
                            <li>
                                registros das mensagens enviadas pelo nosso chatbot para você,
                                incluindo respostas em texto e legendas de documentos.
                            </li>
                        </ul>
                        <p>
                            Atualmente, nosso chatbot foi projetado para interações baseadas em
                            texto. Se conteúdo não textual for recebido pela plataforma WhatsApp,
                            nosso fluxo automatizado atual pode ignorar esse conteúdo, embora
                            metadados relacionados da plataforma ainda possam ser recebidos da Meta.
                        </p>

                        <h2>3. Como Usamos as Informações</h2>
                        <p>Usamos as informações descritas acima para:</p>
                        <ul>
                            <li>receber e processar suas mensagens no WhatsApp;</li>
                            <li>
                                manter um histórico de conversa de curto prazo para que o chatbot
                                responda de forma coerente;
                            </li>
                            <li>
                                classificar o estágio da conversa e determinar a resposta mais
                                adequada;
                            </li>
                            <li>
                                responder perguntas sobre o espaço usando nossa base interna de
                                conhecimento;
                            </li>
                            <li>
                                identificar detalhes relevantes para sua solicitação, como ano do
                                evento, quantidade de convidados e preferência de agenda;
                            </li>
                            <li>
                                enviar materiais de apresentação e documentos de proposta pelo
                                WhatsApp;
                            </li>
                            <li>
                                interromper respostas automatizadas e transferir a conversa para
                                atendimento humano quando o chatbot não estiver confiante ou quando
                                o fluxo exigir assistência humana;
                            </li>
                            <li>
                                monitorar, diagnosticar, proteger e melhorar a confiabilidade do
                                serviço.
                            </li>
                        </ul>
                        <p>
                            Não utilizamos este chatbot para tomar decisões automatizadas que
                            produzam efeitos legais ou efeitos similares relevantes sobre você.
                        </p>

                        <h2>4. Como o Serviço Funciona</h2>
                        <p>
                            Nossa aplicação recebe eventos de webhook da Plataforma do WhatsApp
                            Business. Para mensagens de texto recebidas, o sistema:
                        </p>
                        <ul>
                            <li>verifica se a requisição de webhook veio da Meta;</li>
                            <li>
                                extrai o número de telefone do remetente no WhatsApp e o conteúdo da
                                mensagem;
                            </li>
                            <li>armazena um histórico limitado da conversa em nosso backend;</li>
                            <li>
                                envia mensagens recentes da conversa para um provedor de IA para
                                classificar o estado da conversa e, quando aplicável, responder
                                perguntas com base na nossa base de conhecimento;
                            </li>
                            <li>
                                envia uma resposta de volta para você por meio da Plataforma do
                                WhatsApp Business; e
                            </li>
                            <li>
                                pode enviar documentos em PDF, como apresentações ou propostas,
                                quando forem relevantes para a sua solicitação.
                            </li>
                        </ul>
                        <p>
                            Se o sistema não conseguir responder com confiança suficiente, a
                            conversa pode ser marcada para acompanhamento humano e o bot deixará de
                            responder automaticamente.
                        </p>

                        <h2>5. Serviços de Terceiros e Compartilhamento de Dados</h2>
                        <p>
                            Podemos compartilhar dados pessoais com prestadores de serviços que nos
                            ajudam a operar o chatbot, incluindo:
                        </p>
                        <ul>
                            <li>
                                Meta Platforms, por meio da Plataforma do WhatsApp Business e da
                                Graph API, para receber suas mensagens e entregar nossas respostas;
                            </li>
                            <li>
                                OpenAI, para analisar conteúdo recente da conversa, classificar o
                                estado da conversa e gerar respostas limitadas à nossa base de
                                conhecimento sobre o espaço;
                            </li>
                            <li>
                                nossos provedores de hospedagem, infraestrutura e banco de dados,
                                para armazenar estado da conversa, referências em cache de mensagens
                                e logs do serviço.
                            </li>
                        </ul>
                        <p>
                            Compartilhamos dados apenas na medida razoavelmente necessária para
                            operar, proteger, dar suporte e melhorar o serviço do chatbot.
                        </p>
                        <p>Não vendemos seus dados pessoais.</p>
                        <p>Também poderemos divulgar informações:</p>
                        <ul>
                            <li>
                                quando exigido por lei, regulamento, processo legal ou solicitação
                                governamental;
                            </li>
                            <li>
                                para estabelecer, exercer ou defender direitos em processos ou
                                demandas; ou
                            </li>
                            <li>
                                em conexão com reorganização societária, fusão, aquisição ou
                                transferência de ativos, sujeito à legislação aplicável.
                            </li>
                        </ul>

                        <h2>6. O que Armazenamos e Por Quanto Tempo</h2>
                        <p>Com base na implementação atual do serviço:</p>
                        <ul>
                            <li>
                                o histórico da conversa é armazenado em nosso sistema baseado em
                                Redis por até 30 dias após a atividade mais recente naquela
                                conversa;
                            </li>
                            <li>
                                metadados da conversa derivados da interação, como status
                                ativo/inativo, ano do evento, quantidade de convidados e preferência
                                de período, são armazenados por até 30 dias após a atividade mais
                                recente;
                            </li>
                            <li>
                                referências de mensagens enviadas usadas para compreender o contexto
                                de resposta são armazenadas por até 30 dias;
                            </li>
                            <li>
                                IDs de mídia de documentos do WhatsApp armazenados em cache são
                                mantidos por até 30 dias.
                            </li>
                        </ul>
                        <p>
                            O chatbot mantém apenas um histórico recente limitado para uso ativo,
                            atualmente restrito às 10 mensagens mais recentes no fluxo automatizado.
                        </p>
                        <p>
                            Logs operacionais também podem conter informações técnicas e de
                            diagnóstico. O período de retenção desses logs pode variar conforme o
                            ambiente em que o serviço está hospedado e nossas necessidades
                            operacionais.
                        </p>

                        <h2>7. Documentos que Enviamos</h2>
                        <p>
                            O chatbot pode enviar arquivos como apresentações do espaço e propostas
                            comerciais pelo WhatsApp. Esses arquivos são documentos preparados pela
                            Casa di Pietra para comunicação com clientes. Nosso fluxo automatizado
                            atual não foi projetado para ingerir ou armazenar intencionalmente
                            documentos enviados por clientes como parte da lógica do chatbot.
                        </p>

                        <h2>8. Segurança</h2>
                        <p>
                            Adotamos medidas técnicas e organizacionais razoáveis para proteger os
                            dados pessoais tratados por este serviço. Essas medidas incluem:
                        </p>
                        <ul>
                            <li>
                                validação de assinaturas de webhook da Meta em ambientes de
                                produção;
                            </li>
                            <li>
                                uso de credenciais com controle de acesso para serviços de WhatsApp,
                                IA e banco de dados;
                            </li>
                            <li>
                                limitação do histórico armazenado pelo chatbot e configuração de
                                expiração automática para determinados registros;
                            </li>
                            <li>
                                restrição de respostas automatizadas quando a confiança for
                                insuficiente e possibilidade de acompanhamento humano.
                            </li>
                        </ul>
                        <p>
                            Nenhum sistema é completamente seguro, e não podemos garantir segurança
                            absoluta.
                        </p>

                        <h2>9. Suas Escolhas e Direitos</h2>
                        <p>
                            Dependendo das leis aplicáveis ao seu caso, você pode ter direitos em
                            relação aos seus dados pessoais, como o direito de solicitar acesso,
                            correção, exclusão ou informações adicionais sobre como seus dados são
                            tratados.
                        </p>
                        <p>
                            Você também pode interromper a interação com o chatbot a qualquer
                            momento, bastando deixar de enviar mensagens pelo WhatsApp.
                        </p>
                        <p>
                            Se quiser fazer uma solicitação relacionada à privacidade, entre em
                            contato conosco pelos dados abaixo.
                        </p>

                        <h2>10. Tratamento Internacional</h2>
                        <p>
                            Como utilizamos provedores terceirizados de tecnologia, suas informações
                            podem ser tratadas em países diferentes daquele em que você se encontra,
                            sujeitas às salvaguardas e práticas desses provedores e à legislação
                            aplicável.
                        </p>

                        <h2>11. Privacidade de Crianças</h2>
                        <p>
                            Este serviço é destinado a pessoas que fazem consultas sobre serviços
                            para eventos. Ele não é direcionado a crianças.
                        </p>

                        <h2>12. Alterações nesta Política de Privacidade</h2>
                        <p>
                            Podemos atualizar esta Política de Privacidade periodicamente para
                            refletir mudanças em nossos serviços, fornecedores, práticas ou
                            obrigações legais. Quando isso ocorrer, atualizaremos a data de vigência
                            acima.
                        </p>

                        <h2>13. Fale Conosco</h2>
                        <p>
                            Para dúvidas ou solicitações relacionadas à privacidade, entre em
                            contato:
                        </p>
                        <ul>
                            <li>Razão social: CASA DI PIETRA - VILLA TOSCANA LTDA</li>
                            <li>
                                E-mail:{" "}
                                <a href="mailto:camilamoreira@netcabo.pt">
                                    camilamoreira@netcabo.pt
                                </a>
                            </li>
                            <li>
                                Endereço: Estm. Hilda Beraldi de Almeida, km 5.5, 13.930-000, Serra
                                Negra, São Paulo, Brasil
                            </li>
                        </ul>
                    </article>
                </section>
            </div>
            <Footer />
        </>
    );
}
